import { getApi } from "../client/apiClient";
import type { HttpClient } from "../client/types";
import type { PaginatedResponse } from "../client/types/common.types";
import type {
  CreateUserRequest,
  GetUsersCountRequest,
  GetUsersCountResponse,
  GetUsersRequest,
  User,
} from "../client/types/user.types";

const createUserEndpoints = (client: HttpClient = getApi()) => ({
  getUsers: async (
    params?: GetUsersRequest
  ): Promise<PaginatedResponse<User>> => {
    const { data: response } = await client.get<PaginatedResponse<User>>(
      "/users",
      { params }
    );
    return response;
  },
  getUserById: async (id: string): Promise<User> => {
    const { data: response } = await client.get<User>(`/users/${id}`);
    return response;
  },
  createUser: async (data: CreateUserRequest): Promise<User> => {
    const { data: response } = await client.post<User>("/users", data);
    return response;
  },
  updateUser: async (id: string, data: CreateUserRequest): Promise<User> => {
    const { data: response } = await client.put<User>(`/users/${id}`, data);
    return response;
  },
  getUsersCount: async (params?: GetUsersCountRequest): Promise<GetUsersCountResponse> => {
    const { data: response } = await client.get<GetUsersCountResponse>("/users/count/total", { params });
    return response;
  },
});

export type UserEndpoints = ReturnType<typeof createUserEndpoints>;

export const userEndpoints = createUserEndpoints();
